import moment from "moment";
import modelBaseV2 from "../../model-base-v2.model";

const ACTIONS = {
  SEARCH: "SEARCH",
  DOWNLOAD: "DOWNLOAD",
  RAW: "RAW",
  SELLIN: "SELLIN",
};

const StoreStockoutWithEulaModel = {
  getOptions: () => {
    return modelBaseV2.get("/api/codemaster/ReportEULAStoreStockoutOption");
  },

  getLayoutColumns: () => {
    return modelBaseV2.get("/api/codemaster/ReportEULAStoreStockoutLayout");
  },

  /**
   * Note for config object
   * 
   * sortBy: "" | "ACS" | "DESC"
   * orderBy
   * pageIndex
   * pageSize
   * dateFrom: Week Range - required
   * dateTo: Week Range - required
   * siteGroup: Site Group - code
   * siteCode: Site - siteId
   * assumedSellout
   * reportOption: Options - code - required
   * modelCode: Model Search - modelCode
   * modelAB: Model Search - modelAlias
   * reportType: Layout Columns - code - required
   * reportMode: "SEARCH" | "DOWNLOAD" | "RAW" | "SELLIN"
   * 
   */

  search: (config = {}) => {
    config = { ...config, reportMode: ACTIONS.SEARCH };
    return modelBaseV2.post("/api/report/storestockoutEULA/search", {
      body: config,
    });
  },

  downloadExcel: (config = {}) => {
    return StoreStockoutWithEulaModel._download(
      config,
      ACTIONS.DOWNLOAD,
      `Store_Stockout_With_EULA_Excel_${moment().format(
        "YYYYMMDDhhmm"
      )}.xlsx`
    );
  },

  downloadRawData: (config = {}) => {
    return StoreStockoutWithEulaModel._download(
      config,
      ACTIONS.RAW,
      `Store_Stockout_With_EULA_Raw_Data_${moment().format(
        "YYYYMMDDhhmm"
      )}.xlsx`
    );
  },

  downloadSellInDetails: (config = {}) => {
    return StoreStockoutWithEulaModel._download(
      config,
      ACTIONS.SELLIN,
      `Store_Stockout_With_EULA_Sell_In_Details_${moment().format(
        "YYYYMMDDhhmm"
      )}.xlsx`
    );
  },

  _download: (config = {}, type, filename) => {
    config = { ...config, reportMode: type };
    return modelBaseV2.postDownload(
      `/api/report/storestockoutEULA/${type}`,
      {
        body: config,
      },
      filename
    );
  },
};

export default StoreStockoutWithEulaModel;
